import { combineReducers } from 'redux';
import app from './app';
import flight from './flight';
import hotel from './hotel';
import plan from './plan';
import planDetail from './planDetail';
import planOptions from './planOptions';

const appReducer = combineReducers({
  app,
  flight,
  hotel,
  plan,
  planDetail,
  planOptions,
});

export default appReducer;
